/** `/privacy` and `/terms` (spec §3 legal scaffolding, §5). Not legal advice — reviewed with counsel before global release. */
import { TopBar } from '../components/Widgets.tsx';

export function Privacy() {
  return (
    <div className="page page--paper legal">
      <TopBar />
      <div className="sheet">
        <h1>Privacy Policy</h1>
        <p className="pixel muted">Draft for the US launch · effective 7 September 2026</p>
        <h2>What Draw Earth is</h2>
        <p>Draw Earth is a shared pixel canvas wrapped around the planet. You can only paint where you physically are; anyone can browse and replay any area. Our design principle is to separate <em>who</em>, <em>where</em> and <em>when</em> at the point of storage, not just on screen.</p>
        <h2>Location</h2>
        <p>The app asks for your device location so you can paint on the canvas where you are. Your precise location is sent with each paint request only to check that the pixels are within reach. It is coarsened to a tile identifier (about 280 m) and discarded during the request. It is never logged and never stored. When you draw, we keep only your most recent tile and the time, to detect implausible travel.</p>
        <p>The canvas records, for each pixel, the colour, a time, and an internal account id. Pixel positions are inherent to a public canvas. Public playback is limited to one frame per day, and live activity on the globe is shown only for areas about a kilometre across, delayed, and only when several people are active.</p>
        <h2>Identity</h2>
        <p>Accounts are anonymous: a randomly generated two-word handle and an avatar you draw. Sign-in is handled by Firebase Authentication (Apple, Google or an email link). Your email is used by the sign-in provider for account recovery only. Draw Earth's application database never stores it, and it is never displayed anywhere.</p>
        <h2>What we store</h2>
        <ul>
          <li>Sign-in provider id, handle, avatar, badges, ink balance, notification preferences, push tokens.</li>
          <li>Aggregate stats: pixels painted, areas visited, countries painted in (approximate, from your network).</li>
          <li>Reports you file (kept 12 months) and moderation actions.</li>
          <li>Server request logs for 30 days, without coordinates.</li>
        </ul>
        <p>Profiles are not searchable. There is no "pixels by user" view, no map of your contributions, no location list.</p>
        <h2>Notifications</h2>
        <p>Push and in-app notifications can be switched off individually. They never include coordinates; they link to a tile.</p>
        <h2>Deleting your account</h2>
        <p>You can delete your account from Settings. We delete your sign-in record, handle, avatar, badges, tokens and stats, and reassign your paint events to an anonymous placeholder. Pixels stay on the canvas and in playback, unattributed, so that everyone's shared history stays intact.</p>
        <h2>Age</h2>
        <p>Draw Earth is for people aged 13 and over.</p>
        <h2>Requests</h2>
        <p>For access or deletion requests, use the form in Settings or email privacy@drawearth.app.</p>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <div className="page page--paper legal">
      <TopBar />
      <div className="sheet">
        <h1>Terms of Service</h1>
        <p className="pixel muted">Draft for the US launch · effective 7 September 2026</p>
        <h2>The canvas</h2>
        <p>Anyone can paint over anything. There is no ownership of pixels and no finished works. Pixels persist until painted over; history is kept indefinitely.</p>
        <h2>Rules</h2>
        <ul>
          <li>No hate, harassment, sexual content, or personal information.</li>
          <li>No location spoofing or automation without an agent key.</li>
          <li>No report spam.</li>
        </ul>
        <p>Anyone can report a region. Moderators may remove paint, revert areas, and warn, freeze ink, suspend or ban accounts. Automated systems may act on reports above a confidence threshold; actions are logged and reviewable.</p>
        <h2>Ink</h2>
        <p>Painting spends ink, which refills over time up to a cap. Ink has no cash value.</p>
        <h2>Your content</h2>
        <p>By painting you grant Draw Earth a worldwide, perpetual licence to display, store and replay your pixels as part of the canvas.</p>
        <h2>Termination</h2>
        <p>We may suspend or terminate accounts that break these rules. You may delete your account at any time.</p>
        <h2>Contact</h2>
        <p>legal@drawearth.app</p>
      </div>
    </div>
  );
}
